"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateGridView = exports.onSearch = void 0;
const onSearch = (e, onSearchConnectors, searchString, connectors) => {
    const target = e.target;
    const targetValue = target.value;
    if (targetValue.length > 1) {
        const resultSet = connectors
            .filter(connector => connector.name.toLowerCase().indexOf(targetValue.toLowerCase()) !== -1)
            .filter(c => (c.id !== 'a0n0b00000ODPh2AAH'));
        onSearchConnectors(resultSet, targetValue, searchString);
    }
    else {
        onSearchConnectors([], targetValue, searchString);
    }
};
exports.onSearch = onSearch;
const generateGridView = (connectors, connectorList) => {
    const gridView = [];
    const filteredConnectors = connectors.filter(c => connectorList.includes(c.id));
    filteredConnectors.forEach((connector) => {
        if (!gridView.some(gridViewConnector => (gridViewConnector.id === connector.id))) {
            const copiedConnector = Object.assign({}, connector);
            if (connector.logo == null)
                copiedConnector.logo = '/assets/images/avalara_logo.png';
            gridView.push(copiedConnector);
        }
    });
    return gridView;
};
exports.generateGridView = generateGridView;
